import type {ReactNode} from 'react'
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from '@/components/ui/card'

export interface DetailField {
    label: ReactNode
    value: ReactNode
    fullWidth?: boolean
}

interface DetailsCardProps {
    title: string
    description?: string
    fields: DetailField[]
    columns?: 2 | 3
    'data-testid'?: string
    'data-help-prefix'?: string
}

const GRID_COLS_CLASS: Record<2 | 3, string> = {
    2: 'grid grid-cols-1 md:grid-cols-2 gap-4',
    3: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4',
}

const FULL_WIDTH_CLASS: Record<2 | 3, string> = {
    2: 'md:col-span-2',
    3: 'md:col-span-2 lg:col-span-3',
}

export function DetailsCard({title, description, fields, columns = 2, 'data-testid': testId, 'data-help-prefix': helpPrefix}: DetailsCardProps) {
    return (
        <Card data-testid={testId} data-help-prefix={helpPrefix}>
            <CardHeader>
                <CardTitle data-testid={testId ? `${testId}-title` : 'details-card-title'}>{title}</CardTitle>
                {description && <CardDescription>{description}</CardDescription>}
            </CardHeader>
            <CardContent>
                <dl className={GRID_COLS_CLASS[columns]}>
                    {fields.map((field, index) => (
                        <div key={index} className={field.fullWidth ? FULL_WIDTH_CLASS[columns] : undefined}>
                            <dt className="text-sm font-medium text-muted-foreground">{field.label}</dt>
                            <dd className="mt-1">
                                {field.value === null || field.value === undefined || field.value === ''
                                    ? '—'
                                    : field.value}
                            </dd>
                        </div>
                    ))}
                </dl>
            </CardContent>
        </Card>
    )
}
